import React from 'react'
import ReactLoading from 'react-loading'
import PropTypes from 'prop-types'

import colors from '@settings/styleSettings'
import { Container } from './styles'

const Loading = ({
  color, height, width, style
}) => (
  <Container style={style}>
    <ReactLoading
      type="spin"
      color={color}
      height={height}
      width={width}
    />
  </Container>
)

Loading.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  style: PropTypes.object,
}

Loading.defaultProps = {
  color: colors.titleStrongWhite,
  height: 20,
  width: 20,
  style: null,
}

export default Loading
